/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_EndingInputs */

const en_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A brand new Land Style "Cotton Puddles" for you!

Looking forward to creating more new scenery with you in the forest.`)
};

const ar_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمط الأرض جديد تمامًا "برك القطن" من أجلك!

نتطلع إلى ابتكار المزيد من المناظر الجديدة معك في الغابة.`)
};

const de_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein brandneues Land-Stil "Baumwollpfützen" für Sie! Ich freue mich darauf, mit Ihnen weitere neue Landschaften im Wald zu schaffen.`)
};

const es_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡El nuevo tema "Charcos de algodón" para ti!

Estamos deseando crear más paisajes nuevos contigo en el bosque.`)
};

const fr_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tout nouveau Style de sol «Nuage de Coton» rien que pour vous ! Nous avons hâte de créer encore de nouveaux paysages à vos côtés.`)
};

const it_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nuovissimo Stile del terreno "Soffici Pozzanghere" per te! 
 
Non vedo l'ora di creare altri nuovi scenari con te nella foresta.`)
};

const ja_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいランドスタイル「コットンパッチ」が登場！

これからも森で、一緒に新しい風景を作っていきましょう。`)
};

const ko_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규 랜드 스타일 "폭신폭신 솜뭉치"가 새로 출시되었어요!

숲에서 함께 새로운 풍경을 만들어 보아요.`)
};

const pt_br_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um novíssimo Estilo de terreno para você: "Tapete de algodão"!

Queremos criar mais cenários novos para você na floresta.`)
};

const ru_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совершенно новая Стиль земли «Хлопковые лужицы» для вас!

С нетерпением ждём возможности создать с вами ещё больше новых пейзажей в лесу.`)
};

const th_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สไตล์พื้นดินใหม่ "แอ่งปุยเมฆ" มาแล้วสำหรับคุณ!

มาร่วมกันสร้างทิวทัศน์ใหม่ ๆ ในป่าของคุณไปด้วยกัน`)
};

const tr_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senin için yepyeni Arazi Türü: "Pamuk Birikintileri"
 
Ormanda seninle birlikte daha fazla yeni manzara yaratmayı dört gözle bekliyorum.`)
};

const zh_cn_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全新土地皮肤「棉绵水洼」送给你！

期待和你在森林中创造更多新景色！`)
};

const zh_tw_pro_user_appreciation_letter_ending = /** @type {(inputs: Pro_User_Appreciation_Letter_EndingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全新土地造型「棉綿水窪」送給你！

期待和你在森林中創造更多新景色！`)
};

/**
* | output |
* | --- |
* | "A brand new Land Style \"Cotton Puddles\" for you! Looking forward to creating more new scenery with you in the forest." |
*
* @param {Pro_User_Appreciation_Letter_EndingInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_ending = /** @type {((inputs?: Pro_User_Appreciation_Letter_EndingInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_EndingInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_ending(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_ending(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_ending(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_ending(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_ending(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_ending(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_ending(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_ending(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_ending(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_ending(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_ending(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_ending(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_ending(inputs)
	return zh_tw_pro_user_appreciation_letter_ending(inputs)
});